import { ListBlog } from 'components/Blog/ListBlog';
import RecruitmentLayout from 'layout';
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { getAllBlogs, getLatestTopBlog } from 'services/graphql/directus';
import { BlogType } from 'types';
import { AppEnv } from 'utils/accessEnviroment';

import {
  Menu,
  NormalizeMenu,
  getRecruitmentMenusHeaderAndFooter
} from '@dnse/services';


interface PageProps {
  menusHeader: Menu[];
  menusFooter: NormalizeMenu;
  latestTopBlog: BlogType;
  blogs: BlogType[];
  totalCountBlogs: number;
}

const BlogPage = ({
  menusFooter,
  menusHeader,
  latestTopBlog,
  blogs,
  totalCountBlogs
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return (
    <RecruitmentLayout menusHeader={menusHeader} menusFooter={menusFooter}>
      <ListBlog
        topBlog={latestTopBlog}
        blogs={blogs}
        totalCountBlogs={totalCountBlogs}
      />
    </RecruitmentLayout>
  );
};

export const getStaticProps: GetStaticProps<PageProps> = async () => {
  const [getMenuRes, latestTopBlog] = await Promise.all([
    getRecruitmentMenusHeaderAndFooter(),
    getLatestTopBlog()
  ]);

  const getAllBlogsRes = await getAllBlogs(latestTopBlog?.id || '1');
  return {
    props: {
      menusHeader: getMenuRes.menusHeader,
      menusFooter: getMenuRes.menusFooter,
      latestTopBlog: latestTopBlog || null,
      blogs: getAllBlogsRes.blogs,
      totalCountBlogs: getAllBlogsRes.totalCount
    },
    revalidate: AppEnv.REVALIDATE
  };
};

export default BlogPage;
